import { Pet } from '../../types';

export const PetTitle = {
  [Pet.Dog]: 'Dog',
  [Pet.Cat]: 'Cat',
  [Pet.Exotic]: 'Exotic',
  [Pet.Equine]: 'Equine',
  [Pet.PocketPet]: 'Pocket pet',
};
